// 加密数据为base64位
export function encryptData(data) {
  return window.btoa(encodeURIComponent(JSON.stringify(data)));
}

// 解密base64位数据
export function decryptData(data) {
  return JSON.parse(decodeURIComponent(window.atob(data)));
}

export function setToken(token) {
  return sessionStorage.setItem("token", encryptData(token));
}

export function getToken() {
  const token = sessionStorage.getItem("token");
  return token ? decryptData(token) : null;
}

export function removeToken() {
  return sessionStorage.removeItem("token");
}

export function setLoginUser(info) {
  return sessionStorage.setItem("loginUser", encryptData(info));
}

export function setUserName(userName) {
  return sessionStorage.setItem("userName", userName);
}
 
export function getLoginUser() {
  const loginUser = sessionStorage.getItem("loginUser");
  return loginUser ? decryptData(loginUser) : null;
}

export function removeLoginUser() {
  return sessionStorage.removeItem("loginUser");
}

export function getUserName() {
  const userName = sessionStorage.getItem("userName");
  return userName ? userName : null;
}
